<div #outsideModal class="modal">
    <div #modalBody class="modal-content">
        <div class="modal-header"> {{modalTitle}} </div>
        <div class="modal-body">
            <h3>{{patientInfos}}</h3>
            <div class="table-alarms-container">
                <div class="title-alarms">
                    <div class="icon notification"></div>
                    <h4>Liste des alarmes concernant ce patient</h4>
                </div>
                <frg-table id="alarme" [keysColumn]="alarmeColumnTable" [keysBody]="listAlarmesPatient"
                    tableButton1="assets/icons/trash.svg" (onClick1)="deleteAlarme($event)"
                    (onChangePage)="onChangePageAlarme($event)"></frg-table>
            </div>
            <div class="table-search-container">
                <div class="title-search">
                  <div class="icon search"></div>
                  <h4>Liste des recherches applicables à ce patient</h4>
                </div>
                <frg-table id="search" [keysBody]="recherchesPatient" [keysColumn]="searchColumnTable"
                    (onChangePage)="onChangePageSearch($event)"></frg-table>
            </div>
            <div class="table-rdv-container">
                <div class="title-rdv">
                    <div class="icon alert"></div>
                    <h4>Liste des rendez-vous non honorés</h4>
                </div>
                <frg-table id="rdv" [keysBody]="listRDV" [keysColumn]="rdvColumnTable"
                    (onChangePage)="onChangePageRDV($event)">
                </frg-table>
            </div>
            <div class="button-wrapper">
                <frg-button [type]="'reset'" (activated)="closeAlarmeModal()"
                    [backgroundColor]="'var(--darkest-primary)'">Fermer
                </frg-button>
            </div>
        </div>
    </div>
</div>
<div class="modal-background"></div>>
